module.exports = __webpack_public_path__ + "img/ticket.383b73fb.svg";